var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_851:4718)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 4.03943C6.17879 4.03943 2.71351 6.13005 0.15649 9.52577C-0.0521632 9.80398 -0.0521632 10.1926 0.15649 10.4709C2.71351 13.8707 6.17879 15.9613 10 15.9613C13.8212 15.9613 17.2865 13.8707 19.8435 10.4749C20.0522 10.1967 20.0522 9.80807 19.8435 9.52987C17.2865 6.13005 13.8212 4.03943 10 4.03943ZM10.2741 14.198C7.73755 14.3575 5.64284 12.2669 5.80239 9.72625C5.93331 7.63153 7.63118 5.93367 9.72589 5.80275C12.2625 5.64319 14.3572 7.73381 14.1976 10.2745C14.0626 12.3651 12.3647 14.063 10.2741 14.198ZM10.1473 12.2587C8.78081 12.3446 7.65163 11.2195 7.74164 9.85307C7.81119 8.72389 8.72763 7.81155 9.85681 7.73791C11.2233 7.65199 12.3525 8.77708 12.2625 10.1436C12.1888 11.2768 11.2724 12.1892 10.1473 12.2587Z",
    fill: "#9A9A9A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_851:4718"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEye);
export default __webpack_public_path__ + "static/media/icon-eye.94103d43b01516e7f5e30c02c7e97867.svg";
export { ForwardRef as ReactComponent };